import React, { useState, useEffect } from 'react';
import { myApi } from '../../../../../config/axiosConfig';
import { Grid2, Typography } from '@mui/material';

// COMPONENTES
import MiTabla from '../../../../../components/plantilla/tabla/MiTabla';

const Bafar = () => {

    // =========================================
    // FUNCION PARA BUSCAR UNIDADES ACTIVAS EN DOGO
    // =========================================

    const [bitacora, setBitacora] = useState([]);

    const buscarBitacora = async () => {

        try {

            const response = await myApi.get('/telematica/bafar/bitacora');

            setBitacora(response.data.data);

        } catch (error) {

            console.log(error);

        }

    }

    // =========================================
    // COLUMNAS BITACORA
    // =========================================

    const columnasBitacora = [

        { 
            field: 'strAlias', 
            headerName: 'Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'strGpsID', 
            headerName: 'Placas',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'saved_at', 
            headerName: 'Fecha',
            flex: 1,
            headerAlign: "center",
            align: "center",
            // renderCell: (params) => 
            //     <BtnAcciones
            //         icon={<DeleteIcon />}
            //         label="Eliminar"
            //         onClick={() => handleDeleteDogo(params.row.num_economico)}
            //     />
        },

    ];

    // =========================================
    // USEEFFECT PARA LLAMAR FUNCIONES
    // =========================================

    useEffect(() => {

        buscarBitacora();

    }, []);

    // =========================================

    return (

        <Grid2 container spacing={2}>

            {/* TABLA PARA REGISTROS DE BITACORA */}

            <Grid2 size={12}>

                <Typography
                    variant="h6"
                    textAlign={'center'}
                    fontWeight={700}
                >
                    Registros Bitacora
                </Typography>

                <MiTabla
                    columns={columnasBitacora}
                    data={bitacora}
                />

            </Grid2>

        </Grid2>

    )

}

export default Bafar